var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading
        ? _c(
            "div",
            {
              staticClass: "fixed z-10 grid top-54 left-108 place-items-center",
              style: {
                background: "rgba(255,255,255, 0.5)",
                width: "calc(100vw - 22rem - 5rem - 0.5rem)",
                height: "calc(100vh - 13.5rem - 0.5rem)"
              }
            },
            [_c("div", { staticClass: "blum-loader" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showOrphanBenner
        ? _c(
            "div",
            {
              staticClass:
                "sticky z-20 flex items-center justify-between w-full px-4 h-14 top-42 bg-tomato-200"
            },
            [
              _c(
                "div",
                { staticClass: "sticky z-10 flex items-center gap-4 left-92" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex items-center justify-center flex-shrink-0 w-10 h-10 rounded bg-tomato-300"
                    },
                    [
                      _c("BlIcon", {
                        staticClass: "w-6 h-6",
                        attrs: { icon: "warning", color: "tomato-7" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("BlTextBody2", {
                        staticClass: "font-bold text-tomato-800",
                        attrs: { text: _vm.totalOrphans + " appointment(s)" }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        staticClass: "text-tomato-800",
                        attrs: {
                          text:
                            "don't have a therapist assigned. Please update them."
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "sticky z-10 right-4" },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to:
                          "/appointments?page=1&per_page=25&status=orphan&preview_type=list",
                        target: "_blank"
                      }
                    },
                    [
                      _c("BlInputButton", {
                        attrs: {
                          type: "error",
                          label: "View appointment",
                          dense: ""
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sticky z-20 flex h-12 bg-slate-200",
          class: [_vm.showOrphanBenner ? "top-56" : "top-42"]
        },
        [
          _c("div", {
            staticClass:
              "sticky z-10 flex-shrink-0 w-20 h-12 border-b left-88 bg-slate-200 border-slate-400"
          }),
          _vm._v(" "),
          _vm._l(_vm.headers, function(n, idx) {
            return _c(
              "div",
              {
                key: idx,
                staticClass:
                  "flex items-center justify-center flex-shrink-0 h-12 px-2 py-1 border-b border-slate-400",
                style: { width: "calc(" + _vm.slotWidth + ")" }
              },
              [
                n.highlight
                  ? _c(
                      "div",
                      { staticClass: "flex items-center gap-1 h-7" },
                      [
                        _c("BlTextBody2", {
                          attrs: { text: n.label.split(" ")[0] }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex items-center justify-center rounded-full h-7 w-7 bg-light-purple-400"
                          },
                          [
                            _c("BlTextBody2", {
                              staticClass: "text-pure-white",
                              attrs: { text: n.label.split(" ").pop() }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm.enableBranch && n.branch
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "flex items-center justify-center px-2 truncate rounded h-7",
                        style: {
                          backgroundColor: n.branch.background_color || "unset"
                        },
                        attrs: { title: n.label + " - " + n.branch.name }
                      },
                      [
                        _c("BlTextBody2", {
                          staticClass: "truncate whitespace-no-wrap",
                          style: { color: n.branch.color || "unset" },
                          attrs: { text: n.label }
                        })
                      ],
                      1
                    )
                  : _c(
                      "div",
                      {
                        staticClass: "px-4 truncate h-7",
                        attrs: { title: n.label }
                      },
                      [
                        _c("BlTextBody2", {
                          staticClass: "truncate",
                          attrs: { text: n.label }
                        })
                      ],
                      1
                    )
              ]
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "relative flex flex-col bg-slate-200" },
        [
          _vm._l(_vm.clockRound, function(time) {
            return _c(
              "div",
              {
                key: time,
                staticClass: "flex",
                attrs: { id: "time_view_" + time }
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "sticky z-10 flex justify-end flex-shrink-0 w-20 px-3 py-2 transition-all duration-300 border-b border-r left-88 bg-slate-200 border-slate-400",
                    style: { height: _vm.slotHeight * 2 + "rem" }
                  },
                  [_c("BlTextBody2", { attrs: { text: time } })],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.headers, function(n, idx) {
                  return _c("div", {
                    key: idx,
                    staticClass:
                      "flex flex-col items-center justify-center flex-shrink-0 gap-2 transition-all duration-300 border-b border-r border-slate-400 bg-slate-200",
                    style: {
                      height: _vm.slotHeight * 2 + "rem",
                      width: "calc(" + _vm.slotWidth + ")"
                    }
                  })
                })
              ],
              2
            )
          }),
          _vm._v(" "),
          !_vm.loading
            ? _c(
                "div",
                {
                  staticClass: "absolute flex items-center",
                  style: {
                    opacity: _vm.currentTime.opacity,
                    top: _vm.currentTime.top,
                    left: "calc(" + _vm.currentTime.left + ")",
                    zIndex: 1
                  }
                },
                [
                  _c("div", {
                    staticClass: "flex-shrink-0 w-2 h-2 rounded bg-red-cherry"
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "h-1 bg-red-cherry",
                    style: { width: "calc(" + _vm.currentTime.width + ")" }
                  })
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.availableTimeslots, function(item, idx) {
            return _c("AppointmentsAvailableTimeslot", {
              key: idx,
              attrs: {
                isCompact: _vm.isCompact,
                item: item,
                headers: _vm.headers,
                slotHeight: _vm.slotHeight,
                slotWidth: _vm.slotWidth,
                selectedSlots: _vm.selectedSlots
              },
              on: {
                "add-slot": _vm.onAddSlot,
                "resume-booking": _vm.onResumeBooking,
                "after-commit": function($event) {
                  return _vm.$emit("after-commit")
                }
              }
            })
          }),
          _vm._v(" "),
          _vm._l(_vm.overlappedTimeslots, function(item, idx) {
            return _c("OverlappedTimeslot", {
              key: "overlapped-" + idx,
              attrs: {
                isCompact: _vm.isCompact,
                item: item,
                headers: _vm.headers,
                slotHeight: _vm.slotHeight,
                slotWidth: _vm.slotWidth
              },
              on: {
                "after-commit": function($event) {
                  return _vm.$emit("after-commit")
                }
              }
            })
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "fixed z-50 flex items-center justify-between h-16 px-6 transition-all duration-500 bg-white border rounded shadow-lg w-200 border-slate-400",
              class: [_vm.selectedSlots.length ? "bottom-16" : "-bottom-16"],
              style: {
                left: "50%",
                transform: "translateX(-50%)"
              }
            },
            [
              _c(
                "div",
                { staticClass: "flex items-center gap-2" },
                [
                  _c("BlInputButton", {
                    attrs: { type: "plain", icon: "close" },
                    on: { clicked: _vm.onRemoveSlots }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("BlTextSubtitle3", {
                        staticClass: "text-slate-800",
                        attrs: {
                          text: "Schedule appointment for " + _vm.selectedTime
                        }
                      }),
                      _vm._v(" "),
                      _vm.selectedAvailability
                        ? _c("BlTextSubtitle3", {
                            staticClass: "text-slate-800",
                            attrs: {
                              text:
                                ", " +
                                _vm.displayDate(
                                  _vm.selectedAvailability.date,
                                  "DD MMM YYYY"
                                )
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex items-center gap-2" },
                [
                  _c("BlInputButton", {
                    attrs: { dense: "", label: "Single" },
                    on: {
                      clicked: function($event) {
                        _vm.newSingleOpened = true
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("BlInputButton", {
                    attrs: { dense: "", label: "Recurring" },
                    on: {
                      clicked: function($event) {
                        _vm.newRecurringOpened = true
                      }
                    }
                  })
                ],
                1
              )
            ]
          )
        ],
        2
      ),
      _vm._v(" "),
      _vm.newSingleOpened && _vm.currentUser.role.includes("admin")
        ? _c("NewSingleAppointmentOverlay", {
            attrs: {
              availability: _vm.selectedAvailability,
              slots: _vm.selectedSlots
            },
            on: {
              "close-modal": function($event) {
                _vm.newSingleOpened = false
              },
              "after-commit": function($event) {
                return _vm.$emit("after-commit")
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.newRecurringOpened && _vm.currentUser.role.includes("admin")
        ? _c("NewRecurringAppointmentOverlay", {
            attrs: {
              availability: _vm.selectedAvailability,
              slots: _vm.selectedSlots,
              bookingId: _vm.selectedBookingId
            },
            on: { "close-modal": _vm.onCloseNewRecurring }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54498c7f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54498c7f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointments/timeslot/Timeslots.vue
// module id = null
// module chunks = 